export enum EnumOperationKind {
  PUT = 'put',
  REMOVE = 'remove',
  /** Набор режима events: событие с именем и полезной нагрузкой; состояние собирает модуль свёрткой */
  EVENT = 'event',
}
